<script lang="js" setup>
import TestimonialsCarousel from './TestimonialsCarousel.vue'
</script>

<template>
  <div
    id="testimonials"
    class="max-w-screen-xl 2xl:max-w-screen-2xl mx-6 sm:mx-auto bg-primary-dark rounded-[30px] sm:rounded-[45px] lg:rounded-[60px] py-12 sm:py-16 lg:py-20 xl:py-24 px-4 sm:px-8 lg:px-16 xl:px-28 my-12 sm:my-16 lg:my-20 xl:my-32 flex flex-col gap-y-12 sm:gap-y-16 lg:gap-y-20 xl:gap-y-24 items-center justify-center"
  >
    <div class="flex flex-col gap-y-5 items-center justify-center">
      <h4
        class="uppercase text-center font-black tracking-wide sm:tracking-widest text-lg sm:text-lg lg:text-xl xl:text-2xl bg-txt-gradient bg-clip-text text-transparent"
      >
        Here's what our<br class="block sm:hidden" />users are saying
      </h4>
      <h2
        class="uppercase text-3xl sm:text-4xl lg:text-5xl xl:text-5.5xl leading-none font-bold font-poppins text-white text-center"
      >
        <span class="block sm:inline">Built for Teams Like</span
        ><br class="hidden sm:block" /><span class="block sm:inline"
          >Yours</span
        >
      </h2>
    </div>

    <TestimonialsCarousel />
  </div>
</template>
